import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  store: {
    defaultMessage: 'Store',
    id: 'QcfmPY',
    description: 'Group By Store Label',
  },
  numberOfLineItems: {
    defaultMessage: 'Number of Line Items',
    id: 'hm7siC',
    description: 'Group By Number of Items Label',
  },
  totalQuantity: {
    defaultMessage: 'Total Quantity',
    id: '7NG5o3',
    description: 'Group By Total Quantity Label',
  },
  itemName: {
    defaultMessage: 'Item Name',
    id: 'i0lQ3u',
    description: 'Group By Item Name Label',
  },
  itemSKU: {
    defaultMessage: 'Item SKU',
    id: 'Lwmodi',
    description: 'Group By Item SKU Label',
  },
  requestedService: {
    defaultMessage: 'Requested Service',
    id: 'drXitq',
    description: 'Group By Requested Service Label',
  },
  country: {
    defaultMessage: 'Country',
    id: '9gNmtV',
    description: 'Group By Country Label',
  },
});
